<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>認証コードの検証</h1>
      <p>認証アプリに表示された認証コードを入力してください。</p>
      <p>
        コードが無効な場合は、端末の時刻が自動設定になっているか確認してください。
      </p>
      <form
        [formGroup]="totpVerificationForm"
        (submit)="sendVerificationCodeSubmit($event)"
      >
        <label for="verificationCode">6 桁の認証コード</label>
        <input
          id="verificationCode"
          name="verificationCode"
          placeholder="検証コード"
          inputmode="numeric"
          autocomplete="one-time-code"
          formControlName="verificationCode"
          required
        />
        <button
          type="submit"
          rectangle
          [disabled]="isLoading || totpVerificationForm.invalid"
        >
          送信
        </button>
      </form>
      <button
        rectangle
        variant="secondary"
        [disabled]="isLoading"
        (click)="backToLogin()"
      >
        戻る
      </button>
      <app-loading [showLoading]="isLoading" [fullScreen]="false"></app-loading>
    </div>
  </section>
</div>
